// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import VideoCameraTwoToneSvg from "@fishx/icons-svg/es/asn/VideoCameraTwoTone";
import FishxIcon from '../components/FishxIcon';

var VideoCameraTwoTone = function VideoCameraTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: VideoCameraTwoToneSvg
  }));
};

VideoCameraTwoTone.displayName = 'VideoCameraTwoTone';
export default React.forwardRef(VideoCameraTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/VideoCameraTwoTone.js
// module id = 4380
// module chunks = 0